import { FC } from "react";

import { Column, Locales } from "@simplyk/common";
import { Control, Path, UseFormSetValue, useFormContext } from "react-hook-form";

import { TranslatedTextField } from "../../sharedComponents/TranslatedTextField";
import { ShopVariantValueTranslationFieldData, TicketingTranslationsData } from "../../translation.types";

import { DashboardTextField } from "@/dashboard-design-system/TextField/DashboardTextField";

interface ShopVariantValueTranslationRowProps {
  control: Control<TicketingTranslationsData>;
  setValue: UseFormSetValue<TicketingTranslationsData>;
  column: Column;
  variantIndex: number;
  valueIndex: number;
  fieldValue: ShopVariantValueTranslationFieldData;
  translationValue: ShopVariantValueTranslationFieldData | undefined;
  translationLocale: Locales;
  isTranslationColumn: boolean;
  label: string;
}

export const ShopVariantValueTranslationRow: FC<ShopVariantValueTranslationRowProps> = ({
  control,
  setValue,
  column,
  variantIndex,
  valueIndex,
  fieldValue,
  translationValue,
  translationLocale,
  isTranslationColumn,
  label,
}) => {
  const { register } = useFormContext<TicketingTranslationsData>();
  const valueIdPath =
    `${column}.shopVariantsFields.${variantIndex}.values.${valueIndex}.valueId` as Path<TicketingTranslationsData>;
  const valueNamePath =
    `${column}.shopVariantsFields.${variantIndex}.values.${valueIndex}.name` as Path<TicketingTranslationsData>;

  return (
    <>
      <input type="hidden" {...register(valueIdPath)} value={fieldValue.valueId} />
      {isTranslationColumn ? (
        <TranslatedTextField
          fieldName={valueNamePath}
          defaultFieldValue={fieldValue.name}
          defaultTranslationFieldValue={translationValue?.name || undefined}
          setValue={setValue}
          translationLocale={translationLocale}
          label={label}
          control={control}
          errorMessage={undefined}
          dataTest={`shop-variant-${variantIndex}-value-${valueIndex}-translation`}
        />
      ) : (
        <DashboardTextField
          label={label}
          control={control}
          name={valueNamePath}
          defaultValue={fieldValue.name}
          data-test={`shop-variant-${variantIndex}-value-${valueIndex}-field`}
        />
      )}
    </>
  );
};
